import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mas-upload" }
const _hoisted_2 = { class: "tip" }

import _ from "lodash";
import { UploadFile, UploadFiles, UploadProps, UploadRequestOptions } from "element-plus";
import { reactive, getCurrentInstance, onMounted, ref } from "vue";

const __default__ = { name: "MasUpload" };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  accept: {
    type: String,
    default: "",
  },
  action: {
    type: String,
    default: "",
  },
  multiple: {
    type: Boolean,
    default: false
  },
  drag: {
    type: Boolean,
    default: false
  },
  buttonText: {
    type: String,
    default: "上传文件",
  },
  customCon: {
    type: Boolean,
  },
  limit: {
    type: Number,
    default: 1,
  },
  limitFileSize: {
    type: Number,
    default: 0,
  },
  limitFileSizeTip: {
    type: String,
    default: ""
  },
  customLimitFileSizeTip: {
    type: Boolean,
    default: false
  },
  tip: {
    type: String,
  },
  autoUpload: {
    type: Boolean,
    default: true,
  },
  customClass: {
    type: String
  },
  handleError: {
    type: Boolean,
    default: false
  },
  beforeUpload: {
    type: Function,
  }
},
  setup(__props, { expose }) {

const props = __props

const { proxy } = getCurrentInstance() as any;
const uploadRef = ref<any>(null);

const state:any = reactive({
  fileList: [],
  headers: {
    token: "",
    token_version: "",
  },
});
const handleChange: UploadProps["onChange"] = (
  uploadFile: UploadFile,
  uploadFiles: UploadFiles
) => {
  state.fileList = uploadFiles;
  proxy.$emit("uploadChange", {uploadFile, uploadFiles} ); 
};
const clearFiles = () => {
  // 外部清楚选择的附件 【主要解决删除附件列表不是上传组件本身的删除】
 setTimeout(() => {
   state.fileList = [];
   uploadRef.value.clearFiles();
 }, 30);
}
const handleSuccess: UploadProps["onSuccess"] = (
  response: any,
  uploadFile: UploadFile,
  uploadFiles: UploadFiles
) => {
  if (props.handleError && response.error) {
    proxy.$Message({
      type: "error",
      message: response.error?.message,
    });
    return
  }
  
  proxy.$emit("update:value", uploadFiles);

  // 为了支持上传成功之后直接拿后端返回的数据信息
  proxy.$emit("uploadSuccess", response);
  proxy.$Message({
    type: "success",
    message: "上传成功",
  });
};
// 删除文件
const handleRemove: UploadProps["onRemove"] = (file, uploadFiles) => {
  proxy.$emit("remove", file);
};
const masterFileMax: UploadProps["onExceed"] = (
  files: File[],
  uploadFiles: UploadFiles
) => {
  // 文件数量限制 默认走这里的判断
  proxy.$Message({
    type: "warning",
    message: `最多上传 ${props.limit} 个文件`,
  });
};
const handlePreview: UploadProps["onPreview"] = (uploadFile: UploadFile) => { };
const init = () => {
  const { token, tokenVersion } = (proxy?.$stores as any).store._state.data.states;
  state.headers.token = token;
  state.headers.token_version = tokenVersion;
};

onMounted(() => {
  init();
});

const handleError: UploadProps["onError"] = (
  error: Error,
  uploadFile: UploadFile,
  uploadFiles: UploadFiles
) => {
  proxy.$Message({
    type: "success",
    message: "上传失败",
  });
};

const beforeUpload: UploadProps['beforeUpload'] = (rowFile) => {
  if (props.beforeUpload !== undefined) {
    return props.beforeUpload(rowFile);
  }
  return true;
}

const setFileList = (res: UploadFile) => {
  // 回填file的list res必须为file
  state.fileList.push(res);
};

expose({
  setFileList,
  clearFiles
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_upload, {
      ref_key: "uploadRef",
      ref: uploadRef,
      class: _normalizeClass([__props.customClass ? __props.customClass : '' , "upload-demo"]),
      action: __props.action,
      limit: __props.limit,
      accept: __props.accept,
      "auto-upload": __props.autoUpload,
      multiple: __props.multiple,
      headers: _unref(state).headers,
      "file-list": _unref(state).fileList,
      "on-success": handleSuccess,
      "on-error": handleError,
      "on-change": handleChange,
      "on-exceed": masterFileMax,
      "on-preview": handlePreview,
      "on-remove": handleRemove,
      "before-upload": beforeUpload,
      drag: __props.drag
    }, {
      default: _withCtx(() => [
        (__props.customCon)
          ? _renderSlot(_ctx.$slots, "content", { key: 0 })
          : (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.buttonText), 1)
              ]),
              _: 1
            }))
      ]),
      _: 3
    }, 8, ["class", "action", "limit", "accept", "auto-upload", "multiple", "headers", "file-list", "drag"]),
    _createElementVNode("p", _hoisted_2, _toDisplayString(__props.tip), 1)
  ]))
}
}

})